<img src="/assets/images/logo.png" alt="KVVM" width="250" height="83">
<form [formGroup]="otpForm">
	<input type="hidden" name="sessionID">
	<p>Voer de code van uw authenticator-app in.</p>
	<app-otp-input (completed)="submit($event)"></app-otp-input>
	<button color="primary" mat-button [disabled]="!otpForm.valid">BEVESTIGEN</button>
</form>
<a [routerLink]="['/login-with-recovery-code']">Inloggen met herstelcode?</a>
